import Barcode128 from './Barcode128'

export default Barcode128
